import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import ErrorBoundary from '@src/main/ui/components/common/ErrorPage/ErrorBoundary';
import ThemeProvider from '@src/main/ui/components/common/ThemeProvider/ThemeProvider';
import LoginPage from '@src/main/ui/pages/LoginPage/LoginPage';
import {
  UserThemeContextProvider,
  useUserThemeContext,
} from '@src/main/ui/providers/user/UserThemeContextProvider';
import { Router } from '@src/main/ui/router';
import { FC } from 'react';
import { msalConfig } from './msalConfig';

const App: FC = () => {
  const msalInstance = new PublicClientApplication(msalConfig);
  return (
    <MsalProvider instance={msalInstance}>
      <UserThemeContextProvider>
        <AppScaffolding />
      </UserThemeContextProvider>
    </MsalProvider>
  );
};

const AppScaffolding: FC = () => {
  const { theme } = useUserThemeContext();
  return (
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <AuthenticatedTemplate>
          <Router />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <LoginPage />
        </UnauthenticatedTemplate>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
